module.exports = __webpack_public_path__ + "static/media/meme_3.a2357457.png";